// extracted by mini-css-extract-plugin
export var cta = "CourseTimetable-module--cta--4cf37";
export var divider = "CourseTimetable-module--divider--32a89";
export var holder = "CourseTimetable-module--holder--be064";
export var text = "CourseTimetable-module--text--81851";
export var title = "CourseTimetable-module--title--a1f75";
export var wrapper = "CourseTimetable-module--wrapper--30aa0";